import React from 'react';
import { cn } from '@/lib/utils';

// Single source of truth for the FlexiClean mark. The v2.0 vector masters live in
// public/brand/; use `variant="white"` on navy surfaces so the wave separators stay visible.
export function BrandMark({ variant = 'color', className }) {
  const src = variant === 'white' ? '/brand/isotype-white.svg' : '/brand/isotype.svg';
  return (
    <img
      src={process.env.PUBLIC_URL + src}
      alt="FlexiClean"
      width={32}
      height={32}
      className={cn('h-8 w-8 shrink-0 select-none', className)}
    />
  );
}

// Mark + wordmark. `tone` picks the wordmark colour for light vs navy surfaces.
export function BrandLockup({ tone = 'dark', className, markClassName }) {
  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <BrandMark variant={tone === 'light' ? 'white' : 'color'} className={markClassName} />
      <span
        className={cn(
          'font-display text-lg font-semibold tracking-tight',
          tone === 'light' ? 'text-white' : 'text-foreground',
        )}
      >
        FlexiClean
      </span>
    </div>
  );
}
